import { MantineTheme, createStyles } from "@mantine/styles";

export const useStyles = createStyles((theme: MantineTheme) => ({
  authTitle: {
    fontWeight: "bold",
    marginBottom: "20px",
    marginTop: "20px",
  },
}));
